import {UiApp} from "./components/front/UiApp";
import {MuWidget} from "mu-widget/lib/MuWidget";

let uiApp: UiApp;

export function setupAppPanel(newUiApp: UiApp) {
    uiApp = newUiApp;
}

export async function openInPanel<T=MuWidget>(
    widgetName: string,
    params: Record<string, any> | ((widget: MuWidget) => Record<string, any>) | null = null,
    elementName: string = 'div'
): Promise<T> {
    const wa = uiApp.isPanelOpen ? await uiApp.closePanel() : Promise.resolve();
    const widget = uiApp.muCreateWidget(
        widgetName,
        //todo: Fix muWidget
        document.createElement('div'), // 'panelContent',
        params,
        elementName,
    );
    await wa;
    uiApp.ui.panelContent.append(widget.container);
    uiApp.openPanel(true);

    return widget as T;
}
